import { faTools } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, Route, Switch, useLocation } from 'react-router-dom';
import { Container, Col, Row, ListGroup, ListGroupItem } from 'reactstrap';
import Partners from './Partners/Partners';
import Pimses from './Pims/Pimses';
import BitwerxOfferings from './BitwerxOfferings/BitwerxOfferings';
import MissionControlManager from './PluginManager/MissionControlManager';
import BulkManifestUpdate from './BulkManifestUpdate/BulkManifestUpdate';
import AccountsPage from 'v2/pages/accounts';
import Accounts from './Accounts/Accounts';

const linkStyle = { textDecoration: 'none' };

const settingsLink = (url, label, pathname) => (
    <Link to={`/admin/${url}`} style={linkStyle}>
        <ListGroupItem action active={pathname.includes(url)}>
            <h5>{label}</h5>
        </ListGroupItem>
    </Link>
);

const Admin = () => {
    const loc = useLocation();

    return (
        <Container className="sc-glass text-light">
            <Row>
                <Col lg="2" className="p-2 overflow-auto">
                    <ListGroup>
                        <Link to="/admin" style={linkStyle}>
                            <ListGroupItem>
                                <h2 className="text-secondary">
                                    <FontAwesomeIcon icon={faTools} size="sm" />
                                    &nbsp; Settings
                                </h2>
                            </ListGroupItem>
                        </Link>
                        {settingsLink('accounts', 'Accounts', loc.pathname)}
                        {settingsLink('partners', 'Partners', loc.pathname)}
                        {settingsLink('pims', 'Pims', loc.pathname)}
                        {settingsLink(
                            'bitwerxofferings',
                            'Bitwerx Offerings',
                            loc.pathname
                        )}
                        {settingsLink(
                            'mission-control-manager',
                            'Mission Control Manager',
                            loc.pathname
                        )}
                        {settingsLink(
                            'bulk-manifest-update',
                            'Bulk Manifest Update',
                            loc.pathname
                        )}
                    </ListGroup>
                </Col>
                <Col lg="10" className="p-2">
                    <Switch>
                        <Route path="/admin/accounts" component={Accounts} />
                        <Route path="/admin/accounts-new" component={AccountsPage} />
                        <Route path="/admin/pims" component={Pimses} />
                        <Route path="/admin/partners" component={Partners} />
                        <Route
                            path="/admin/bitwerxofferings"
                            component={BitwerxOfferings}
                        />
                        <Route
                            path="/admin/mission-control-manager"
                            component={MissionControlManager}
                        />
                        <Route
                            path="/admin/bulk-manifest-update"
                            component={BulkManifestUpdate}
                        />
                        <Route
                            component={() => (
                                <Container className="p-3">
                                    <h1>Settings</h1>
                                    <h3>Select a category to get started</h3>
                                </Container>
                            )}
                        />
                    </Switch>
                </Col>
            </Row>
        </Container>
    );
};

export default Admin;
